import React, {MouseEvent, useCallback, useContext} from 'react';
import {DropDownV2Context, Text} from '@priority-software/priority-style-react';
import {DropdownValueType} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';

type TriggerProps = {
    value: DropdownValueType;
    disabled?: boolean;
};

const style = {textDecoration: 'underline', cursor: 'pointer'};

export const TextTrigger = (props: TriggerProps) => {
    const {value} = props;
    const {isOpen, openDropdown, closeDropdown} = useContext(DropDownV2Context);

    const handleToggle = useCallback(
        (e: MouseEvent<HTMLElement>) => {
            if (isOpen) {
                closeDropdown();
            } else {
                openDropdown();
            }
        },
        [isOpen, closeDropdown, openDropdown]
    );

    return (
        <div
            onClick={e => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                handleToggle(e);
            }}
        >
            <Text textColor={isOpen ? 'primary-500' : 'primary-700'} skin="label-1" style={style}>
                {`${value}`}
            </Text>
        </div>
    );
};
